import React from "react";
import logoImg from "./logo.svg"

function App() {
  return (
    <div style={{ backgroundImage:`url(${logoImg})`,
            backgroundSize:"cover",
            backgroundRepeat: "no-repeat",  
            height: "98vh",
            marginTop:"-18px", 
            textAlign: "center"}}>
      
      <p style={{paddingTop:"50px",color:"white", fontSize:"100%", textAlign:"center"}}>Welcome to Xomento</p>
      <h1 style={{color:"white", fontSize:"100%", textAlign:"center"}}> Comming Soon....</h1>
    </div>
  );
}


export default App;